import React, { useState } from 'react';
import { Container, Button, FormGroup, Label, Col, Row, Alert } from 'reactstrap';
import { Redirect } from "react-router-dom";
import { Field, ErrorMessage, Form, Formik } from "formik";
import * as Yup from 'yup';
import { addBodyClasses } from "../utils";
import { CONTRIBUTOR_BASE_URL } from "../../utils";
import moment from "moment-timezone";
import differenceInYears from "date-fns/differenceInYears";
import axios from "axios";

const queryString = require('query-string');

function SignUp() {
  const [formError, setFormError] = useState(null);
  const [completedSignUp, setCompletedSignUp] = useState(false);
  const [name, setName] = useState(null);

  const parsed = queryString.parse(window.location.search);
  const mode = parsed.mode || 'raf';
  const edition = parsed.edition || 'measure';
  const pid = parsed.pid;
  const c = parsed.c;
  const onboard_template = parsed.onboard_template || 'default';
  const joinURL = parsed.join_url || window.location.href;
  const source = parsed.source;
  const community_slug = parsed.community_slug || 'msr';
  let title = 'Create MSR Account';
  let show_refer_code = true;

  if (community_slug.includes('arno')) {
      title = 'Create MSR-meant Account';
      show_refer_code = false;
  }

  const termsURL = 'https://contributor.measureprotocol.com/app/terms';
  const privacyURL = 'https://contributor.measureprotocol.com/app/privacy';

  // pre-populate fields
  const code = parsed.code;

  const downloadURL = {
    'raf': `/download?edition=${edition}&name=${name}&code=${code}`,
    'web-retro-cpc': `/download?edition=${edition}&name=${name}&code=${code}`,
    'af': `/web-registration-download?edition=${edition}&c=${c}&pid=${pid}&onboard_template=${onboard_template}&source=${source}&community_slug=${community_slug}`,
  }[mode];

  addBodyClasses(['sign-up-page'])();

  if (completedSignUp) {
    return <Redirect to={downloadURL} />;
  } else {
    return (
      <Container fluid="sm">

         {source === "nextdoor" &&
             <img className="hide" height="1" width="1" src="https://flask.nextdoor.com/pixel?pid=90e78a85-50ea-45e7-979e-697bbeb972fc&ev=PAGE_VIEW&noscript=1" />
         }

        {formError &&
          <Row>
            <Col>
              <Alert color="danger" isOpen={true} toggle={() => { setFormError(null) }}>
                {formError}
              </Alert>
            </Col>
          </Row>
        }

        <Row>
          <Col>

            <h1>{title}</h1>
            <p>Fill out the form to create your account.</p>
          </Col>
        </Row>

        <Row>
          <Col>
            <Formik
              initialValues={{
                first_name: parsed.first_name,
                last_name: parsed.last_name,
                email: parsed.email,
                password: '',
                password_again: '',
                dob: '',
                invited_by_code: code,
                has_accepted_terms: false,
                save_profile_data_to_inbox: true,
                timezone: moment.tz.guess(),
                join_url: joinURL,
                community_slug: parsed.community_slug,
                community_user_id: parsed.community_user_id
              }}
              validationSchema={Yup.object({
                first_name: Yup.string().required('Required'),
                last_name: Yup.string().required('Required'),
                dob: Yup.date().required('Required').test("dob", "You should be 13 or older", function (value) {
                  return differenceInYears(new Date(), new Date(value)) >= 13;
                }),
                password: Yup.string().min(8, 'Your password must be at least 8 characters').required('Required'),
                password_again: Yup.string().oneOf([Yup.ref('password'), null], "Passwords don't match").required('Required'),
                email: Yup.string().email('Invalid email address').required('Required'),
                invited_by_code: Yup.string().min(4, 'Not a valid code'),
                has_accepted_terms: Yup.bool().oneOf([true], 'Confirm your age and agreement')
              })}
              validateOnChange={false}
              onSubmit={(values, { setSubmitting }) => {
                axios.post(`${CONTRIBUTOR_BASE_URL}/join`, values)
                  .then(function (response) {
                    setSubmitting(false);
                    setName(values.first_name);
                    setCompletedSignUp(true);
                  })
                  .catch(function (error) {
                    setFormError("There was a problem creating your account. Please try again.");
                    setSubmitting(false);
                  });
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  <Row form>
                    <Col xs={6}>
                      <FormGroup>
                        <Label for="first_name">First Name</Label>
                        <Field name="first_name" id="first_name" label="First Name" className="form-control" />
                        <ErrorMessage name="first_name" component="div" className="inline-error" />
                      </FormGroup>
                    </Col>
                    <Col xs={6}>
                      <FormGroup>
                        <Label for="last_name">Last Name</Label>
                        <Field name="last_name" id="last_name" label="Last Name" className="form-control" />
                        <ErrorMessage name="last_name" component="div" className="inline-error" />
                      </FormGroup>
                    </Col>
                  </Row>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <Field type="email" name="email" id="email" label="Email" className="form-control" />
                    <ErrorMessage name="email" component="div" className="inline-error" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="dob">Date of Birth</Label>
                    <Field type="date" name="dob" id="dob" label="Date of birth" className="form-control" />
                    <ErrorMessage name="dob" component="div" className="inline-error" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="password">Password</Label>
                    <Field type="password" name="password" id="password" label="Password" className="form-control" />
                    <ErrorMessage name="password" component="div" className="inline-error" />
                  </FormGroup>
                  <FormGroup>
                    <Label for="password_again">Password, again</Label>
                    <Field type="password" name="password_again" id="password_again" label="Password, again" className="form-control" />
                    <ErrorMessage name="password_again" component="div" className="inline-error" />
                  </FormGroup>
                    { show_refer_code &&
                        <FormGroup>
                            <Label for="invited_by_code">Referral Code</Label>
                            <Field name="invited_by_code" id="invited_by_code" label="Referral code"
                                   className="form-control"/>
                            <ErrorMessage name="invited_by_code" component="div" className="inline-error"/>
                        </FormGroup>
                    }
                  <FormGroup check>
                    {/*<Input name="terms" id="terms" type="checkbox" value="true" />*/}
                    <div className="custom-control custom-checkbox">
                      <Field name="has_accepted_terms" id="has_accepted_terms" type="checkbox" className="custom-control-input" />
                      {/*<div className="control-indicator"/>{' '}*/}
                      <Label className="custom-control-label form-check-label" for="has_accepted_terms">
                        I am 13+ years of age and agree to the
                        {' '} <a href={termsURL} target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and
                        {' '} <a href={privacyURL} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                      </Label>
                      <ErrorMessage name="has_accepted_terms" component="div" className="inline-error" />
                    </div>
                  </FormGroup>
                  {/*<FormGroup>*/}
                  {/*  <div className="custom-control custom-checkbox">*/}
                  {/*    <input type="checkbox" className="custom-control-input" id="customCheck1" />*/}
                  {/*      <label className="custom-control-label" htmlFor="customCheck1">Check this custom*/}
                  {/*        checkbox*/}
                  {/*      </label>*/}
                  {/*  </div>*/}
                  {/*</FormGroup>*/}
                  {/*<FormGroup check>*/}
                  {/*  <Label check className="custom-control control-checkbox">*/}
                  {/*    /!*<Input name="terms" id="terms" type="checkbox" value="true" />*!/*/}
                  {/*    <Field name="has_accepted_terms" id="has_accepted_terms" type="checkbox" />*/}
                  {/*    <div className="control-indicator"/>{' '}*/}
                  {/*    I am 18+ years of age and agree to the*/}
                  {/*    {' '} <a href={termsURL} target="_blank" rel="noopener noreferrer">Terms & Conditions</a> and*/}
                  {/*    {' '} <a href={privacyURL} target="_blank" rel="noopener noreferrer">Privacy Policy</a>*/}
                  {/*  </Label>*/}
                  {/*  <ErrorMessage name="has_accepted_terms" component="div" className="inline-error" />*/}
                  {/*</FormGroup>*/}
                  <Row form>
                    <Col>
                      <div className="action-button">
                        <Button type="submit" color="primary" disabled={isSubmitting}>Create account</Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
            </Formik>
          </Col>
        </Row>

      </Container>
    );
  }
}

export default SignUp;
